import React, { useEffect, useState } from "react";
import "./MyProfile.css";
import { useNavigate } from "react-router-dom";
import { IP } from '../../internalServer';
import AvaterPop from "./Avater/AvaterPop";
import AvatarSuccessfulPopup from './AvatarSuccessfulPopup';

export default function MyProfile({ handleProfileClose, classTeachers, coOrdinators }) {

  const [studentDetails, setStudentDetails] = useState("");
  const [click, setClick] = useState(false)
  const [getResponse, setGetResponse] = useState(false)
  const [resMessage, setResMessage] = useState({})
  console.log(studentDetails);
  const navigate = useNavigate();
  useEffect(() => {
    let data = JSON.parse(localStorage.getItem("breathForStudent"));
    setStudentDetails(data);
  }, []);

  function formatDate(inputDate) {
    const inputDateFormat = new Date(inputDate);
    const day = inputDateFormat.getDate().toString().padStart(2, "0");
    const month = (inputDateFormat.getMonth() + 1).toString().padStart(2, "0");
    const year = inputDateFormat.getFullYear().toString().substr();
    return `${day}-${month}-${year}`;
  }
  function findClassTeacherName(objects) {
    for (let i = 0; i < objects?.length; i++) {
      if (objects[i].is_class_teacher === true) {
        return objects[i].teacher.name;
      }
    }
  }

  // function handleLogoutClick() {
  //   localStorage.removeItem("ActiveHeader");
  //   localStorage.removeItem("homeSideMenu");
  //   localStorage.removeItem("hwSideMenu");
  //   localStorage.removeItem("summarySideMenu");
  //   localStorage.removeItem("engageSideMenu");
  //   localStorage.removeItem("hasShownPopupCalender");
  //   localStorage.removeItem("dropdownval");
  //   localStorage.removeItem("from");
  //   localStorage.removeItem("hasShownPopupAssessment");
  //   localStorage.removeItem("hasShownPopupSelfAssessment");
  //   localStorage.removeItem("hasShownPopupSummary");
  //   localStorage.removeItem("hasShownPopupCommumity");
  //   localStorage.removeItem("hasShownPopupQuery");
  //   localStorage.removeItem("std");
  //   localStorage.removeItem("sec");
  //   localStorage.removeItem("sub");
  //   localStorage.removeItem("LastSeen");
  //   localStorage.removeItem("isContinue");
  //   localStorage.removeItem("clickedChap");
  //   localStorage.removeItem("hasShownPopupActivity");
  //   localStorage.removeItem("hasShownPopupHW");
  //   localStorage.removeItem("hasShownPopupPR");
  //   localStorage.removeItem("School_id");
  //   localStorage.removeItem("AuthToken");
  //   localStorage.removeItem("studentInformation");
  //   localStorage.removeItem("breathForStudent");
  //   localStorage.removeItem("footerActive");
  //   localStorage.removeItem("ActiveBtn");
  //   localStorage.removeItem("ActiveBtn");
  //   localStorage.removeItem("Header");

  //   navigate("/");
  //   handleProfileClose();
  // }

  const handleLogoutClick = () => {
    clearLocalStorage();
    navigate("/");
    classTeachers = []
    coOrdinators = []
    handleProfileClose();
  };

  const clearLocalStorage = () => {
    localStorage.clear();
  };

  useEffect(() => {
    const handleTabClose = () => {
      clearLocalStorage();
    };

    window.addEventListener("beforeunload", handleTabClose);

    return () => {
      window.removeEventListener("beforeunload", handleTabClose);
    };
  }, []);

  const [showPopup, setShowPopup] = useState(false);

  const handleClick = () => {
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), 5000);
  };

  return (
    <div className="p-4 w-full myprofileContaienr">
      <div className="  d-flex justify-content-between ">
        <div className="d-flex gap-4">
          <div
            onClick={handleProfileClose}
            style={{ cursor: "pointer" }}
            className="d-flex align-items-center"
          >
            <img src="/LoginRegister/LoginBackIcon.png" alt="icon" />
          </div>
          <div className=" HeaderTitle d-flex align-items-center">
            My Profile
          </div>
        </div>

        <div className='d-flex gap-4'>
          {showPopup && (
            <div className="pop mr-0">
              <div className="pop-content">
                <span className="clos" onClick={() => setShowPopup(false)}>
                  &times;
                </span>
                <div className="clos">Coming Soon</div>
              </div>
            </div>
          )}
          <div style={{ cursor: 'pointer' }} onClick={handleClick}>
            {/* <img src='/StudentImg/notifcationIcon.png' alt='icon'></img> */}
          </div>
          <div style={{ cursor: 'pointer' }} >
            <img
              src={
                studentDetails?.profile_picture
                  ? IP + studentDetails?.profile_picture.replace(/^\./, "")
                  : studentDetails?.gender === "M"
                    ? studentDetails?.avatar_profile ? '/images/Boys/' + studentDetails?.avatar_profile + '.webp'
                      : "/images/Student_boy_pic.png"
                    : studentDetails?.gender === "F"
                      ? studentDetails?.avatar_profile ? '/images/Girls/' + studentDetails?.avatar_profile + '.webp'
                        : "/images/Student_girl_pic.png"
                      : "/images/default image.png"
              }
              alt="icon"
              className=""
              style={{ width: "40px", height: "40px", borderRadius: "50%", cursor: "pointer" }}
              key={studentDetails?.avatar_profile}
              onError={(e) => {
                if (studentDetails?.gender === "M") {
                  e.target.src = studentDetails?.avatar_profile ? '/images/Boys/' + studentDetails?.avatar_profile + '.webp' : "/images/Student_boy_pic.png"
                } else if (studentDetails?.gender === "F") {
                  e.target.src = studentDetails?.avatar_profile ? '/images/Girls/' + studentDetails?.avatar_profile + '.webp' : "/images/Student_girl_pic.png"
                } else {
                  e.target.src = "/images/default image.png"
                }
              }}
            />
          </div>
        </div>
      </div>
      <div>
        <p className="logout" onClick={handleLogoutClick}>
          Logout
        </p>
      </div>
      <div className="d-flex justify-content-between align-items-center gap-3" style={{ position: "relative" }}>
        <div className="editImage" onClick={() => setClick(true)}>
          <img className="editProfileImage" src="./images/pencil-edit.png" alt="img" />
          <p className="edit" onClick={() => setClick(true)}>Edit</p>
        </div>
        <div className="d-flex containerProfileDetailImg">
          <div
            className="uploadFileBtn_MasterData"
            style={{ cursor: "pointer", marginRight: "20px" }}
          >
            <input type="file" id="attachFile" accept=".jpg,.jpeg,.png,.pdf,.ppt,.pptx,.mp3,.mp4,.webp" style={{ display: "none" }} />
            <label htmlFor="attachFile">
              <img
                src={
                  studentDetails?.profile_picture
                    ? IP + studentDetails?.profile_picture.replace(/^\./, "")
                    : studentDetails?.gender === "M"
                      ? studentDetails?.avatar_profile ? '/images/Boys/' + studentDetails?.avatar_profile + '.webp'
                        : "/images/Student_boy_pic.png"
                      : studentDetails?.gender === "F"
                        ? studentDetails?.avatar_profile ? '/images/Girls/' + studentDetails?.avatar_profile + '.webp'
                          : "/images/Student_girl_pic.png"
                        : "/images/default image.png"
                }
                alt="icon"
                className=""
                style={{ width: "70px", height: "70px", borderRadius: "50%", cursor: "pointer" }}
                key={studentDetails?.avatar_profile}
                onError={(e) => {
                  if (studentDetails?.gender === "M") {
                    e.target.src = studentDetails?.avatar_profile ? '/images/Boys/' + studentDetails?.avatar_profile + '.webp' : "/images/Student_boy_pic.png"
                  } else if (studentDetails?.gender === "F") {
                    e.target.src = studentDetails?.avatar_profile ? '/images/Girls/' + studentDetails?.avatar_profile + '.webp' : "/images/Student_girl_pic.png"
                  } else {
                    e.target.src = "/images/default image.png"
                  }
                }}
              />
            </label>

          </div>
          <div className="d-flex align-items-center studentNameProfile">
            {studentDetails?.name}
          </div>
        </div>
      </div>

      <div className="row containerProfileDetail" style={{ margin: "85px 55px" }}>
        <div className="col-md-8">
          <div className="row">
            <div className="col-md-8">
              <div className="">
                <div className="prfielDetailHeader">Gender</div>
                <div className="prfielDetailtext">
                  {studentDetails?.gender === "M" ? "Male" : "Female"}
                </div>
              </div>
              <div className="mt-4">
                <div className="prfielDetailHeader">School Email Id</div>
                <div className="prfielDetailtext">{studentDetails?.email}</div>
              </div>
              {/* <span className='d-flex justify-content-end lgout' onClick={()=>{window.location.replace("/")}}>Logout</span> */}
              <div className="mt-4">
                <div className="prfielDetailHeader">Father Name</div>
                <div className="prfielDetailtext">
                  {studentDetails?.father?.name}
                </div>
              </div>
              <div className="mt-4">
                <div className="prfielDetailHeader">Contact Number</div>
                <div className="prfielDetailtext">
                  {studentDetails?.mobile_number}
                </div>
              </div>
              {/* <div className='mt-4'>
                                <div className='prfielDetailHeader'>MDM ID / IMEI</div>
                                <div className='prfielDetailtext'>{}</div>
                            </div> */}

              <div className="mt-4">
                <div className="prfielDetailHeader">Class</div>
                <div className="prfielDetailtext ml-2">
                  {" "}
                  {studentDetails?.standard?.name}
                </div>
              </div>

              <div className="mt-4">
                <div className="prfielDetailHeader">Division</div>
                <div className="prfielDetailtext  ml-2">
                  {" "}
                  {studentDetails?.section?.name}
                </div>
              </div>
              <div className="mt-4">
                <div className="prfielDetailHeader">Co-Ordinators</div>
                <div className="prfielDetailtext  ml-2">
                  {coOrdinators.join(',  ')}
                </div>
              </div>



            </div>
            <div className="col-md-4">
              <div className="d-flex gap-3"></div>
              <div>
                <div className="prfielDetailHeader">DOB</div>
                <div className="prfielDetailtext">
                  {formatDate(studentDetails?.date_of_birth)}
                </div>
              </div>
              <div className="mt-4">
                <div className="prfielDetailHeader">Parents Email Id</div>
                <div className="prfielDetailtext">
                  {studentDetails?.father?.Email
                    ? studentDetails?.father?.Email
                    : studentDetails?.mother?.Email}
                </div>
              </div>
              <div className="mt-4">
                <div className="prfielDetailHeader">Mother Name</div>
                <div className="prfielDetailtext">
                  {studentDetails?.mother?.name}
                </div>
              </div>
              <div className="mt-4">
                <div className="prfielDetailHeader">Alternative Number</div>
                <div className="prfielDetailtext">
                  {studentDetails?.emergency_contact_number}
                </div>
              </div>
              <div className="mt-4">
                <div className="prfielDetailHeader">Roll No</div>
                <div className="prfielDetailtext">
                  {studentDetails?.code}
                </div>
              </div>


              <div className="mt-4">
                <div className="prfielDetailHeader">Class Teacher</div>
                <div className="prfielDetailtext">
                  {/* {findClassTeacherName(studentDetails?.teacher_information)} */}
                  {/* {classTeachers.map((list) => <span className="d-flex">{list}</span>)} */}
                  {classTeachers.join(',  ')}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4"></div>
      </div>
      {click && <AvaterPop setStudentDetails={setStudentDetails} studentDetails={studentDetails} setClick={setClick} setResMessage={setResMessage} setGetResponse={setGetResponse} handleProfileClose={handleProfileClose} />}
      {getResponse && <AvatarSuccessfulPopup handleProfileClose={handleProfileClose} setGetResponse={setGetResponse} resMessage={resMessage} setResMessage={setResMessage} />}
    </div>
  );
}
